import React, { useState, useEffect } from 'react';
import '../../VendorStyles/Offers.css';
import axiosVendorInstance from '../../axiosVendorInstance';
import { toast } from 'react-toastify';
import OfferModal from './OfferModal';
import DeleteOfferModal from './DeleteOfferModal';
import { useAuth } from '../../AuthProvider';
import EditPencilIconSvg from '../../assets/svg/editPencilIcon';
import DeleteIconSvg from '../../assets/svg/deleteIcon';
import CommonButton from '../../Components/commonButton';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Loader from '../../Components/Loader/Loader';

function Offers() {
    const { userID } = useAuth();

    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [vendorID, setVendorID] = useState();
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [openForm, setOpenForm] = useState(false);
    const [deleteOfferId, setDeleteOfferId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const fetchVendorID = async () => {
        try {
            const response = await axiosVendorInstance.get(
                '/vendors/account'
            );
            const apiResponse = response?.data?.getVendorInfo;

            if (apiResponse?.length > 0) {
                setVendorID(apiResponse[0]?.ID);
            } else {
                toast.error('Vendor ID not found.');
            }
        } catch (error) {
            toast.error('Error fetching vendor ID');
        }
    };

    useEffect(() => {
        if (userID) {
            fetchVendorID();
        }
    }, [userID]);

    const fetchOffers = async () => {
        if (!vendorID) return;

        try {
            const response = await axiosVendorInstance.get(
                `/vendor/offers/vendor/${vendorID}`,
                { skipAuth: true }
            );
            setCoupons([response?.data?.offers] || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (vendorID) {
            fetchOffers();
        }
    }, [vendorID]);

    const handleOpenForm = (offer = null) => {
        setOpenForm(true);
        setSelectedOffer(offer);
    };

    const handleCloseForm = () => {
        setOpenForm(false);
        setSelectedOffer(null);
    };

    const handleDeleteClick = (offerId) => {
        setDeleteOfferId(offerId);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        try {
            await axiosVendorInstance.delete(`/vendor/offers/${deleteOfferId}`, {
                skipAuth: true,
            });
            setCoupons((prevCoupons) =>
                prevCoupons.filter((offer) => offer.id !== deleteOfferId)
            );
            toast.success('Offer deleted successfully!');
            fetchOffers();
        } catch (error) {
            toast.error('Error deleting offer.');
        }
        setShowDeleteModal(false);
    };

    const cancelDelete = () => {
        setDeleteOfferId(null);
        setShowDeleteModal(false);
    };

    return (
        <div className="Offers-main-div">
            <div className="add-button-coupen-offer">
                <div></div>
                <h2 className='coupons-heading'>Added Offers</h2>
                <CommonButton
                    onClick={() => handleOpenForm()}
                    label="Add Offer"
                />
            </div>
            {openForm && (
                <OfferModal
                    open={openForm}
                    handleClose={handleCloseForm}
                    initialData={selectedOffer}
                    fetchOffers={fetchOffers}
                />
            )}

            <div className="table-container">
                {loading ? (
                    <Loader />
                ) : coupons.length > 0 ? (
                    <>
                        <TableContainer component={Paper}>
                            <Table className="coupon-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Image</TableCell>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Percentage</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Short Description</TableCell>
                                        <TableCell>Valid From</TableCell>
                                        <TableCell>Valid To</TableCell>
                                        <TableCell>Maximum Amount</TableCell>
                                        <TableCell>Redeem Limit</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {coupons[0]?.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                <img
                                                    src={item?.Avatar_key || 'https://omfmedia.s3.ap-southeast-1.amazonaws.com/files/20221129181320/omg-logo-grey.png'}
                                                    alt={item?.Title}
                                                    className="table-img"
                                                    width="50"
                                                    height="50"
                                                />
                                            </TableCell>
                                            <TableCell>{item?.Title}</TableCell>
                                            <TableCell>{item?.percentage}%</TableCell>
                                            <TableCell>{item?.Description && item?.Description.length > 100 ? item?.Description.slice(0, 100) + '...' : item?.Description}</TableCell>
                                            <TableCell>{item?.shortdescription && item?.shortdescription.length > 100 ? item?.shortdescription.slice(0, 100) + '...' : item?.shortdescription}</TableCell>
                                            <TableCell>{!item?.noboundaries ? item?.valid_from?.split('T')[0] : 'N/A'}</TableCell>
                                            <TableCell>{!item?.noboundaries ? item?.valid_to?.split('T')[0] : 'N/A'}</TableCell>
                                            <TableCell>{item?.Max_amount}</TableCell>
                                            <TableCell>{item?.Offer_redemlimit}</TableCell>
                                            <TableCell>{item?.status}</TableCell>
                                            <TableCell>
                                                <div className="edit-and-delete-icons-container">
                                                    <EditPencilIconSvg 
                                                        color='green'
                                                        onClick={() => handleOpenForm(item)}
                                                    />
                                                    <DeleteIconSvg 
                                                        onClick={() => handleDeleteClick(item.ID)} 
                                                        color='#e13535'
                                                    />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {showDeleteModal && (
                            <DeleteOfferModal
                                open={handleDeleteClick}
                                handleClose={cancelDelete}
                                confirmDelete={confirmDelete}
                                cancelDelete={cancelDelete}
                                message="Are you sure you want to delete this offer?"
                            />
                        )}
                    </>
                ) : (
                    <p className='no-coupons'>No offers found.</p>
                )}
            </div>
        </div>
    );
}

export default Offers;
